import { z } from "zod";

// Create an advertiser/merchant ("brand") under a source. `source_id` is required here (the brand's
// network); it is immutable afterwards (see update-product-brand-request). Bounds mirror V003
// (external_id VARCHAR(100), name VARCHAR(200)).
export const createProductBrandRequestSchema = z.object({
  source_id: z.number().int(),
  external_id: z.string().min(1, "External ID is required").max(100),
  name: z.string().min(1, "Name is required").max(200),
  active: z.boolean().optional(),
});
